import { makeStyles } from "@mui/styles";
import { Colors } from "../helpers/Colors";
import { fontSize } from "../helpers/fontSize";

export const Modal_useStyles = makeStyles({
  Modal_Background: {
    zIndex: 1,
    backgroundColor: Colors.secondaryBgOpacity,
    position: "absolute",
    margin: "auto",
    width: "full",
    height: "100%",
    // opacity: 0.6,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  Update_Import_Modal: {
    zIndex: 2,
    overflow: "hidden",
    position: "absolute",
    margin: "auto",
    // opacity: 1,
    width: "fit-content",
    height: "fit-content",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: `${Colors.white} !important`,
    padding: "20px !important",
    borderRadius: "10px",
    boxShadow: `0px 3px 10px ${Colors.primary}`,
    // box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    "@media only screen and (max-Width: 1165px) ": {
      width: "fit-content",
      height: "fit-content",
    },
    "@media only screen and (max-Width: 430px) ": {
      width: "75%",
      height: "fit-content",
    },
    "& .Import_Modal_Container": {
      width: "100%",
      height: "100%",
      position: "relative",
      "& .closeIconCon_Relative": {
        "& .closeIcon_Relative": {
          cursor: "pointer",
          position: "sticky   ",
          zIndex: 3,
          position: "absolute",
          border: `3px solid ${Colors.primary}`,
          color: Colors.primary,
          fontSize: "25px",
          borderRadius: "20px",
          top: -6,
          right: -5,
          "@media only screen and (max-Width: 430px) ": {
            fontSize: "20px",
          },
        },
      },
      "& .update": {
        padding: "0px 0px 6px 0px",
        fontSize: fontSize.update_delete,
        fontWeight: 600,
      },
      "& .delete": {
        display: "flex",
        flexDirection: "column",
        "& .deleteName": {
          padding: "0px 0px 15px 0px",
          fontSize: fontSize.update_delete,
          fontWeight: 600,
        },
        "& label": {
          width: "400px",
          fontWeight: 450,
          fontSize: fontSize.paragraph,
          padding: "0px 0px 15px 0px",
          // --------- from xs(380px) till md(770px)
          "@media only screen and (max-Width: 600px)": {
            width: "300px",
          },
          "@media only screen and (max-Width: 770px) ": {
            width: "300px",
            fontSize: fontSize.Tablet_paragraph,
            padding: "0px 0px 10px 0px",
          },
          "& .content": {
            color: Colors.black,
            fontWeight: 600,
          },
        },
      },
      "& .Submit_Con": {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "0px 0px 0px 0",
        margin: "10px 0px 0px 0px",
        "@media only screen and (max-Width: 770px) ": {
          display: "flex",
          flexDirection: "column",
        },
        "& label": {
          fontSize: "18px",
          color: Colors.labelText,
        },
        "& button": {
          padding: "10px 10px",
          margin: "2px 0px 0 0 ",
          outline: "none",
          border: `2px solid ${Colors.inputBg}`,
          backgroundColor: Colors.primary,
          fontSize: "16px",
          borderRadius: "5px",
          color: Colors.sidebarWhite,
          "@media only screen and (max-Width: 770px) ": {},
        },
        "& ::placeholder": {},
      },
    },
  },
});
